import * as types from './window.actionTypes';

export default {
  setWindow: data => ({
    type: types.DIALOG_WINDOW_SET_WINDOW,
    payload: data,
  }),

  removeWindow: data => ({
    type: types.DIALOG_WINDOW_REMOVE_WINDOW,
    payload: data,
  }),

  setHighlighted: data => ({
    type: types.DIALOG_WINDOW_HIGHLIGHTED_WINDOW,
    payload: data,
  }),

  resetWindow: () => ({
    type: types.RESET_WINDOW,
  }),
};
